module.exports = __webpack_public_path__ + "img/lightening-rounded.28354aa9.svg";